var m = require('mithril');

module.exports = {
  view: function (vnode) {
    const options = vnode.attrs || {};

    return m('div.pointer.ba.bw1.ph3.tc.v-btm', {
      style: options.style || {},
      class: options.class,
      onclick: function () {
        if (typeof options.func === 'function') {
          options.func();
        }
      },
    }, options.label || options.children);
  }
};

